<ul>
  @for (item of items; track item) {
    <li>
      <strong>{{ item.name }}</strong
      >&nbsp;
      <span>{{ item.remark }}</span>
    </li>
  }
</ul>
